export default __webpack_public_path__ + "static/media/GES_C_WHITE.5d325a0d.png";